import { NgModule } from '@angular/core';

import { ImageSelectorComponent } from './image-selector.component';

@NgModule({
  imports: [ImageSelectorComponent],
  exports: [ImageSelectorComponent]
})
export class ImageSelectorModule {}
